import { gql } from "@apollo/client";

export const GlobalGridInducteesFragment = gql`
  fragment GridInductees on FlexiblePageContentContentGridInducteesLayout {
      headline
      colorOverride
      cta {
        linkType
        label
        externalLink
        page {
          node {
            uri
          }
        }
      }
    }
`;